import React from "react";
import { Link } from "react-router";
import {
    CalendarDay,
    getDayNameFromLabel,
    getMonthName,
    PrayerHour,
} from "../../calendar/utils";
import { Padding } from "../../shared-components/Padding";
import { LegacyRubric } from "./LegacyRubric";
import { Spacer } from "./Spacer";

export const Heading: React.FC<{
    day: CalendarDay;
    hour: PrayerHour;
}> = (props) => {
    const { day, hour } = props;

    return (
        <Padding>
            <div style={{ textAlign: "center" }}>
                <div
                    style={{
                        fontWeight: "bold",
                        letterSpacing: 2,
                        textTransform: "uppercase",
                        fontSize: "140%",
                        paddingBottom: 4,
                        paddingTop: 32,
                    }}
                >
                    {hour.toLocaleUpperCase()}
                </div>
                <div
                    style={{
                        fontWeight: "bold",
                        fontSize: "90%",
                        paddingBottom: 32,
                    }}
                >
                    {
                        {
                            mon: "Monday",
                            tues: "Tuesday",
                            wed: "Wednesday",
                            thur: "Thursday",
                            fri: "Friday",
                            sat: "Saturday",
                            sun: "Sunday",
                        }[day.dayOfTheWeek]
                    }{" "}
                    {day.date} {getMonthName(day.month)} {day.year}
                </div>
                {day.eveOf && hour !== "mattins" ? (
                    <>
                        <div
                            style={{
                                fontWeight: "bold",
                                letterSpacing: 0.3,
                                fontSize: "90%",
                                textTransform: "uppercase",
                            }}
                        >
                            The eve of
                        </div>
                        <div
                            style={{
                                fontWeight: "bold",
                                letterSpacing: 0.3,
                                fontSize: "125%",
                                paddingBottom: 32,
                            }}
                        >
                            {getDayNameFromLabel(day.eveOf.label ?? "")}
                        </div>
                    </>
                ) : day.label ? (
                    <div
                        style={{
                            fontWeight: "bold",
                            letterSpacing: 0.3,
                            fontSize: "150%",
                            paddingBottom: 32,
                            paddingLeft: 16,
                            paddingRight: 16,
                        }}
                    >
                        {getDayNameFromLabel(day.label)}
                    </div>
                ) : day.blackLetterDay ? (
                    day.blackLetterDay.optional ? (
                        <div
                            style={{
                                paddingBottom: 32,
                                paddingLeft: 16,
                                paddingRight: 16,
                                fontSize: 18,
                            }}
                        >
                            Commonly celebrated as:<br></br>
                            {getDayNameFromLabel(day.blackLetterDay.title)}
                        </div>
                    ) : (
                        <div
                            style={{
                                paddingBottom: 32,
                                paddingLeft: 16,
                                paddingRight: 16,
                                fontSize: 18,
                            }}
                        >
                            {getDayNameFromLabel(day.blackLetterDay.title)}
                        </div>
                    )
                ) : (
                    <></>
                )}
                {day.label === "ash-wednesday" && hour === "mattins" ? (
                    <>
                        <Spacer />
                        <LegacyRubric>
                            <strong>NOTE ON ASH WEDNESDAY</strong>
                            <br />
                            It is appropriate on Ash Wednesday to conclude
                            Mattins with{" "}
                            <strong style={{ textDecoration: "underline" }}>
                                <Link to="/pray/litany">The&nbsp;Litany</Link>
                            </strong>{" "}
                            and{" "}
                            <strong style={{ textDecoration: "underline" }}>
                                <Link to="/pray/commination">
                                    The&nbsp;Commination
                                </Link>
                            </strong>
                            . Links for doing so will be found at the
                            appropriate points in Mattins and the Litany.
                        </LegacyRubric>
                        <Spacer big />
                    </>
                ) : (
                    <></>
                )}
            </div>
        </Padding>
    );
};
